module.exports = "<svg viewBox=\"0 0 143.5 145.9\"><path fill=\"#1E1E1C\" d=\"M140.8 19.2H2.7C1.2 19.2 0 18 0 16.5V2.7C0 1.2 1.2 0 2.7 0h138.1c1.5 0 2.7 1.2 2.7 2.7v13.8c0 1.5-1.2 2.7-2.7 2.7zm0 126.7H2.7c-1.5 0-2.7-1.2-2.7-2.7v-13.8c0-1.5 1.2-2.7 2.7-2.7h138.1c1.5 0 2.7 1.2 2.7 2.7v13.8c0 1.4-1.2 2.7-2.7 2.7zm0-63.3H2.7c-1.5 0-2.7-1.2-2.7-2.7V66.2c0-1.5 1.2-2.7 2.7-2.7h138.1c1.5 0 2.7 1.2 2.7 2.7V80c0 1.4-1.2 2.6-2.7 2.6z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/burger.svg
// module id = 240
// module chunks = 1